/* Component Dependencies */
var suggestedFiltersTemplate = require('templates/suggestedFilters.hbs');
var AriesComponent = require('libs/aries-component');
var Constants = require('libs/constants');
var $ = require('jquery');

AriesComponent.create({
  type: 'suggestedFilters',
  template: {
    'suggestedFilters': suggestedFiltersTemplate
  },
  subscribe: {
    'SRP_VIEW_CHANGED': 'srpViewChanged'
  },
  events: {
    'click .l-pill': 'submitPayload'
  },
  options: {
    'SUGGESTED_FILTER_FORM': '.suggested-filter-form'
  },
  /**
   * Method to show suggested pills only on list view
   */
  srpViewChanged: function (selectedView) {
    if (selectedView !== Constants.SRP_VIEW.LIST) {
      this.$el.hide();
    } else {
      if(this.$el.find('ul.l-pill-container li').length == this.$el.find('ul.l-pill-container li.hidden').length) {
        this.$el.hide();
      } else {
        this.$el.show();
      }
      // Fix to avoid sticky MI SLIDER
      $(document).resize();
    }
  },

  submitPayload: function (event) {
    var payload = {
      selectionOrder: [],
      rangeFilter: [{ "price": [] }, { "distance": [] }],
      facets: [],
      action: this.$el.find('input[name=action]').val(),
      showAvailableHotels: this.$el.find('input[name=showAvailableHotels]').val(),
      isHotelsNearMe: this.$el.find('input[name=isHotelsNearMe]').val()
    },
    selectedFilters = [];
    $target = $(event.currentTarget);
    
    // Return control if count is zero
    if($target.data('count') == 0) {
      return false;
    }
    
    // toggle selected class
    $target.toggleClass('selected');

    // Let's take out all the selected filters in a list
    this.$el.find('a.l-pill').each(function () {
      var isSelected = $(this).hasClass('selected');
      if (isSelected) {
        selectedFilters.push($(this));
      }
    });

    // Let's work on selected filters now
    selectedFilters.forEach(function (filterElem) {
      var data = filterElem.data();

      if (data.filtertype == 'facet') {
        payload.selectionOrder.push({
          "bucketName": data.filterkey,
          "code": data.code,
          "label": data.label + " " + "("+ data.count +")"
        });
      } else {
        if (data.filterkey == 'price') {
          payload.rangeFilter[0]["price"].push(data.code + '');
        } else {
          payload.rangeFilter[1]["distance"].push(data.code + '');
        }
      }
    });

    // Creating facets array
    payload.facets = [payload.selectionOrder.reduce(function(facets, filter) {
      if(!facets[filter.bucketName]) {
        facets[filter.bucketName] = [];
      }
      facets[filter.bucketName].push(filter.code);
      return facets;
    }, {})];


    // Let's submit the form
    this.$el.find("input[name='selectionOrder']").val(JSON.stringify(payload.selectionOrder));
    this.$el.find("input[name='rangeFilter']").val(JSON.stringify(payload.rangeFilter));
    this.$el.find("input[name='facets']").val(JSON.stringify(payload.facets));
    this.$el.find(this.options.SUGGESTED_FILTER_FORM).submit();
  }
});
